import React, { useCallback, useEffect, useState } from "react";
import PersonalInfo from "./OnboardingSteps/PersonalInfo";
import OnboardingHeader from "./OnboardingHeader";
import OnboardingButtons from "./OnboardingButtons/OnboardingButtons";
import BusinessInfo from "./OnboardingSteps/BusinessInfo";
import UploadDocument from "./OnboardingSteps/UploadDocument";
import { useDispatch } from "react-redux";
import {
  addUserAddidtionalQuestionsAPI,
  getCityStateDistrictByPinCode,
  getUserAddidtionalQuestionsAPI,
  getUserDetailsInOnboarding,
} from "../../../../Store/Action/onboardingAction";
import { registerUserAPI } from "../../../../Store/Action/authAction";
import { useLocation, useNavigate } from "react-router-dom";
import { setOnboardingFlag } from "../../../../Store/Slice/onboardingSlice";
import { setOnboardingCompleted } from "../../../../Store/Slice/authSlice";
import "./onboardingStyle.css";
import HeaderBlack from "../../WelcomeScreen/Common/Header";
const Onboarding = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [currentStep, setCurrentStep] = useState(0);
  const [isSubmitDisabled, setSubmitDisabled] = useState(true);
  const [totalQueLen, setTotalQueLen] = useState(0);
  const [userAdditionalInfo, setUserAdditionalInfo] = useState([]);
  //get user additional data values
  const [userOnboardingDetails, setUserOnboardingDeatils] = useState({});
  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    whatsAppNumber: "",
    userEmail: "",
    address: "",
    pinCode: "",
    city: "",
    district: "",
    state: "",
    referralCode: "",
    shopName: "",
    workEmailAddress: "",
    gstCheckbox: null,
    turnOver: null,
    gstNumber: "",
    companyDocumentNumber: "",
    companyPanNumber: "",
    retailerOrWholesaler: "",
    panCardFile: "",
    companyDocumentFile: "",
    GSTDocumentFile: "",
    visitingCardFile: "",
    tdsDeclarationFile: "",
  });

  useEffect(() => {
    if (Object.keys(userOnboardingDetails).length > 0) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        firstName: userOnboardingDetails.firstName || "",
        lastName: userOnboardingDetails.lastName || "",
        whatsAppNumber:
          userOnboardingDetails.whatsAppNumber ||
          sessionStorage.getItem("onboardingMobileNumber") ||
          "",
        userEmail: userOnboardingDetails.userEmail || "",
        address: userOnboardingDetails.address || "",
        pinCode: userOnboardingDetails.pinCode || "",
        city: userOnboardingDetails.city || "",
        district: userOnboardingDetails.district || "",
        state: userOnboardingDetails.state || "",
        referralCode: userOnboardingDetails.referralCode || "",
        shopName: userOnboardingDetails.shopName || "",
        workEmailAddress: userOnboardingDetails.workEmailAddress || "",
        gstCheckbox: userOnboardingDetails.gstCheckbox ?? null,
        turnOver: userOnboardingDetails.turnOver ?? null,
        gstNumber: userOnboardingDetails.gstNumber || "",
        companyDocumentNumber:
          userOnboardingDetails.companyDocumentNumber || "",
        companyPanNumber: userOnboardingDetails.companyPanNumber || "",
        retailerOrWholesaler: userOnboardingDetails.retailerOrWholesaler || "",
        panCardFile: userOnboardingDetails.panCardFile || "",
        companyDocumentFile: userOnboardingDetails.companyDocumentFile || "",
        GSTDocumentFile: userOnboardingDetails.GSTDocumentFile || "",
        visitingCardFile: userOnboardingDetails.visitingCardFile || "",
        tdsDeclarationFile: userOnboardingDetails.tdsDeclarationFile || "",
      }));
    }
  }, [userOnboardingDetails]);

  useEffect(() => {
    const mobileNumber = location?.state?.userMobileNumber;

    if (mobileNumber) {
      // ✅ strip +91 prefix and any spaces
      const cleanedNumber = mobileNumber.replace(/^\+91\s*/, "").trim();
      sessionStorage.setItem("onboardingMobileNumber", cleanedNumber);
      setFormData((prev) => ({
        ...prev,
        whatsAppNumber: cleanedNumber,
      }));
    } else {
      // ✅ fallback from sessionStorage on refresh
      const savedMobile = sessionStorage.getItem("onboardingMobileNumber");
      if (savedMobile) {
        const cleanedNumber = savedMobile.replace(/^\+91\s*/, "").trim();
        setFormData((prev) => ({
          ...prev,
          whatsAppNumber: cleanedNumber,
        }));
      }
    }
  }, [location?.state]);

  const [userAdditionalQuestionsId, setUserAdditionalQuestionsId] = useState(
    {},
  );

  const [userAdditionalQuestions, setUserAdditionalQuestions] = useState({});
  const [queSeqNum, setQueSeqNum] = useState({});
  const [isRequireFields, setIsrequireFields] = useState({});

  const handleMouseOutForPinCode = () => {
    const pinCode = formData.pinCode;
    dispatch(
      getCityStateDistrictByPinCode(pinCode, (result) => {
        if (result?.status) {
          // setFormData({
          //   ...formData,
          //   state: result?.data?.user_state,
          //   // city: result?.data?.user_city,
          //   district: result?.data?.user_district,
          // });
          setFormData((prev) => ({
            ...prev,
            state: result?.data?.user_state || prev.state,
            // city: result?.data?.user_city || prev.city,
            district: result?.data?.user_district || prev.district,
          }));
        }
      }),
    );
    handleUserAdditionalInfoAnswers();
  };
  // Handle back button click
  const handleBackClick = () => {
    // if(currentStep == 1){

    //   setErrors((prev)=>({
    //     ...prev,
    //     refferalCode:""
    //   }))
    // }
    setCurrentStep((prevStep) => Math.max(prevStep - 1, 0));
    refreshData();
  };

  // Handle next button click
  const handleNextClick = () => {
    if (validateCurrentStep()) {
      setCurrentStep((prevStep) => Math.min(prevStep + 1, totalSteps - 1));
      refreshData();
      handleUserAdditionalInfoAnswers();
    }
  };
  //get user details in onboarding
  useEffect(() => {
    dispatch(
      getUserDetailsInOnboarding({}, (result) => {
        if (result && Array.isArray(result?.data)) {
          const firstNameVal = result?.data?.find(
            (item) => item?.generic_name === "firstName",
          );
          const lastNameVal = result?.data?.find(
            (item) => item?.generic_name === "lastName",
          );
          const whatAppNumberVal = result?.data?.find(
            (item) => item?.generic_name === "whatsAppNumber",
          );

          const userEmailVal = result?.data?.find(
            (item) => item?.generic_name === "userEmail",
          );
          const addressVal = result?.data?.find(
            (item) => item?.generic_name === "address",
          );
          const pinCodeVal = result?.data?.find(
            (item) => item?.generic_name === "pinCode",
          );
          const cityVal = result?.data?.find(
            (item) => item?.generic_name === "city",
          );
          const districtVal = result?.data?.find(
            (item) => item?.generic_name === "district",
          );
          const stateVal = result?.data?.find(
            (item) => item?.generic_name === "state",
          );
          const referralCodeVal = result?.data?.find(
            (item) => item?.generic_name === "referralCode",
          );
          const shopNameVal = result?.data?.find(
            (item) => item?.generic_name === "shopName",
          );
          const officeEmailInfoVal = result?.data?.find(
            (item) => item?.generic_name === "workEmailAddress",
          );
          const gstButtonOptionsVal = result?.data?.find(
            (item) => item?.generic_name === "gstCheckbox",
          );
          const businessTurnOverVal = result?.data?.find(
            (item) => item?.generic_name === "turnOver",
          );
          const gstNumberInfoVal = result?.data?.find(
            (item) => item?.generic_name === "gstNumber",
          );
          const companyDocumentNumberInfoVal = result?.data?.find(
            (item) => item?.generic_name === "companyDocumentNumber",
          );
          const companyPanNumberInfoVal = result?.data?.find(
            (item) => item?.generic_name === "companyPanNumber",
          );
          const userRoleInfoVal = result?.data?.find(
            (item) => item?.generic_name === "retailerOrWholesaler",
          );
          const panCardUploadInfoVal = result?.data?.find(
            (item) => item?.generic_name === "uploadPanCard",
          );

          const gstInUploadInfoVal = result?.data?.find(
            (item) => item?.generic_name === "uploadGstDocument",
          );
          const companyOfficialDocumentUploadInfoVal = result?.data?.find(
            (item) => item?.generic_name === "companyOfficialDocument",
          );
          const vistingCardUploadInfoVal = result?.data?.find(
            (item) => item?.generic_name === "visitingCard",
          );
          const tdsDeclarationUploadInfoVal = result?.data?.find(
            (item) => item?.generic_name === "tdsDeclaration",
          );

          setUserOnboardingDeatils((prevState) => ({
            ...prevState,
            firstName: firstNameVal?.user_additional_information_data_value,
            lastName: lastNameVal?.user_additional_information_data_value,
            whatsAppNumber:
              whatAppNumberVal?.user_additional_information_data_value,
            userEmail: userEmailVal?.user_additional_information_data_value,
            address: addressVal?.user_additional_information_data_value,
            pinCode: pinCodeVal?.user_additional_information_data_value,
            city: cityVal?.user_additional_information_data_value,
            district: districtVal?.user_additional_information_data_value,
            state: stateVal?.user_additional_information_data_value,
            referralCode:
              referralCodeVal?.user_additional_information_data_value,
            shopName: shopNameVal?.user_additional_information_data_value,
            workEmailAddress:
              officeEmailInfoVal?.user_additional_information_data_value,
            gstCheckbox:
              gstButtonOptionsVal?.user_additional_information_data_value,
            turnOver:
              businessTurnOverVal?.user_additional_information_data_value,
            gstNumber: gstNumberInfoVal?.user_additional_information_data_value,
            companyDocumentNumber:
              companyDocumentNumberInfoVal?.user_additional_information_data_value,
            companyPanNumber:
              companyPanNumberInfoVal?.user_additional_information_data_value,
            retailerOrWholesaler:
              userRoleInfoVal?.user_additional_information_data_value,
            panCardFile:
              panCardUploadInfoVal?.user_additional_information_data_value,
            GSTDocumentFile:
              gstInUploadInfoVal?.user_additional_information_data_value,
            companyDocumentFile:
              companyOfficialDocumentUploadInfoVal?.user_additional_information_data_value,
            visitingCardFile:
              vistingCardUploadInfoVal?.user_additional_information_data_value,
            tdsDeclarationFile:
              tdsDeclarationUploadInfoVal?.user_additional_information_data_value,
          }));
        }
      }),
    );
  }, [dispatch]);

  // const refreshUserAddidtionalData = ()=>{

  // }

  //refresh data on back , next button
  const refreshData = () => {
    dispatch(
      getUserDetailsInOnboarding({}, (result) => {
        if (result && Array.isArray(result?.data)) {
          const firstNameVal = result?.data?.find(
            (item) => item?.generic_name === "firstName",
          );
          const lastNameVal = result?.data?.find(
            (item) => item?.generic_name === "lastName",
          );
          const whatAppNumberVal = result?.data?.find(
            (item) => item?.generic_name === "whatsAppNumber",
          );

          const userEmailVal = result?.data?.find(
            (item) => item?.generic_name === "userEmail",
          );
          const addressVal = result?.data?.find(
            (item) => item?.generic_name === "address",
          );
          const pinCodeVal = result?.data?.find(
            (item) => item?.generic_name === "pinCode",
          );
          const cityVal = result?.data?.find(
            (item) => item?.generic_name === "city",
          );
          const districtVal = result?.data?.find(
            (item) => item?.generic_name === "district",
          );
          const stateVal = result?.data?.find(
            (item) => item?.generic_name === "state",
          );
          const referralCodeVal = result?.data?.find(
            (item) => item?.generic_name === "referralCode",
          );
          const shopNameVal = result?.data?.find(
            (item) => item?.generic_name === "shopName",
          );
          const officeEmailInfoVal = result?.data?.find(
            (item) => item?.generic_name === "workEmailAddress",
          );
          const gstButtonOptionsVal = result?.data?.find(
            (item) => item?.generic_name === "gstCheckbox",
          );
          const businessTurnOverVal = result?.data?.find(
            (item) => item?.generic_name === "turnOver",
          );
          const gstNumberInfoVal = result?.data?.find(
            (item) => item?.generic_name === "gstNumber",
          );
          const companyDocumentNumberInfoVal = result?.data?.find(
            (item) => item?.generic_name === "companyDocumentNumber",
          );
          const companyPanNumberInfoVal = result?.data?.find(
            (item) => item?.generic_name === "companyPanNumber",
          );
          const userRoleInfoVal = result?.data?.find(
            (item) => item?.generic_name === "retailerOrWholesaler",
          );
          const panCardUploadInfoVal = result?.data?.find(
            (item) => item?.generic_name === "uploadPanCard",
          );
          const gstInUploadInfoVal = result?.data?.find(
            (item) => item?.generic_name === "uploadGstDocument",
          );
          const companyOfficialDocumentUploadInfoVal = result?.data?.find(
            (item) => item?.generic_name === "companyOfficialDocument",
          );
          const vistingCardUploadInfoVal = result?.data?.find(
            (item) => item?.generic_name === "visitingCard",
          );
          const tdsDeclarationUploadInfoVal = result?.data?.find(
            (item) => item?.generic_name === "tdsDeclaration",
          );

          setUserOnboardingDeatils((prevState) => ({
            ...prevState,
            firstName: firstNameVal?.user_additional_information_data_value,
            lastName: lastNameVal?.user_additional_information_data_value,
            whatsAppNumber:
              whatAppNumberVal?.user_additional_information_data_value,
            userEmail: userEmailVal?.user_additional_information_data_value,
            address: addressVal?.user_additional_information_data_value,
            pinCode: pinCodeVal?.user_additional_information_data_value,
            city: cityVal?.user_additional_information_data_value,
            district: districtVal?.user_additional_information_data_value,
            state: stateVal?.user_additional_information_data_value,
            referralCode:
              referralCodeVal?.user_additional_information_data_value,
            shopName: shopNameVal?.user_additional_information_data_value,
            workEmailAddress:
              officeEmailInfoVal?.user_additional_information_data_value,
            gstCheckbox:
              gstButtonOptionsVal?.user_additional_information_data_value,
            turnOver:
              businessTurnOverVal?.user_additional_information_data_value,
            gstNumber: gstNumberInfoVal?.user_additional_information_data_value,
            companyDocumentNumber:
              companyDocumentNumberInfoVal?.user_additional_information_data_value,
            companyPanNumber:
              companyPanNumberInfoVal?.user_additional_information_data_value,
            retailerOrWholesaler:
              userRoleInfoVal?.user_additional_information_data_value,
            panCardFile:
              panCardUploadInfoVal?.user_additional_information_data_value,
            GSTDocumentFile:
              gstInUploadInfoVal?.user_additional_information_data_value,
            companyDocumentFile:
              companyOfficialDocumentUploadInfoVal?.user_additional_information_data_value,
            visitingCardFile:
              vistingCardUploadInfoVal?.user_additional_information_data_value,
            tdsDeclarationFile:
              tdsDeclarationUploadInfoVal?.user_additional_information_data_value,
          }));
        }
      }),
    );
  };

  //get all the user additional questions
  useEffect(() => {
    dispatch(
      getUserAddidtionalQuestionsAPI({}, (result) => {
        if (result && Array.isArray(result?.data)) {
          const firstName = result?.data?.find(
            (item) => item?.generic_name === "firstName",
          );
          const lastName = result?.data?.find(
            (item) => item?.generic_name === "lastName",
          );
          const whatsAppNumber = result?.data?.find(
            (item) => item?.generic_name === "whatsAppNumber",
          );
          const userEmail = result?.data?.find(
            (item) => item?.generic_name === "userEmail",
          );
          const address = result?.data?.find(
            (item) => item?.generic_name === "address",
          );
          const pinCode = result?.data?.find(
            (item) => item?.generic_name === "pinCode",
          );
          const city = result?.data?.find(
            (item) => item?.generic_name === "city",
          );
          const district = result?.data?.find(
            (item) => item?.generic_name === "district",
          );
          const state = result?.data?.find(
            (item) => item?.generic_name === "state",
          );
          const referralCode = result?.data?.find(
            (item) => item?.generic_name === "referralCode",
          );
          const shopName = result?.data?.find(
            (item) => item?.generic_name === "shopName",
          );
          const officeEmailInfo = result?.data?.find(
            (item) => item?.generic_name === "workEmailAddress",
          );
          const gstButtonOptions = result?.data?.find(
            (item) => item?.generic_name === "gstCheckbox",
          );
          const businessTurnOver = result?.data?.find(
            (item) => item?.generic_name === "turnOver",
          );
          const gstNumberInfo = result?.data?.find(
            (item) => item?.generic_name === "gstNumber",
          );
          const companyDocumentNumberInfo = result?.data?.find(
            (item) => item?.generic_name === "companyDocumentNumber",
          );
          const companyPanNumberInfo = result?.data?.find(
            (item) => item?.generic_name === "companyPanNumber",
          );
          const userRoleInfo = result?.data?.find(
            (item) => item?.generic_name === "retailerOrWholesaler",
          );
          const panCardUploadInfo = result?.data?.find(
            (item) => item?.generic_name === "uploadPanCard",
          );
          const gstInUploadInfo = result?.data?.find(
            (item) => item?.generic_name === "uploadGstDocument",
          );
          const companyOfficialDocumentUploadInfo = result?.data?.find(
            (item) => item?.generic_name === "companyOfficialDocument",
          );
          const vistingCardUploadInfo = result?.data?.find(
            (item) => item?.generic_name === "visitingCard",
          );
          const tdsDeclarationUploadInfo = result?.data?.find(
            (item) => item?.generic_name === "tdsDeclaration",
          );

          setUserAdditionalQuestionsId((prevState) => ({
            ...prevState, // Retain existing state
            firstNameId: firstName?.user_additional_information_id || null, // ID for firstName
            lastNameId: lastName?.user_additional_information_id || null, // ID for lastName
            whatsAppNumberId:
              whatsAppNumber?.user_additional_information_id || null, // ID for whatAppNumber
            userEmailId: userEmail?.user_additional_information_id || null, // ID for userEmail
            addressId: address?.user_additional_information_id || null, // ID for address
            pinCodeId: pinCode?.user_additional_information_id || null, // ID for pinCode
            cityId: city?.user_additional_information_id || null, // ID for city
            districtId: district?.user_additional_information_id || null, // ID for district
            stateId: state?.user_additional_information_id || null, // ID for state
            referralCodeId:
              referralCode?.user_additional_information_id || null, // ID for referralCode
            shopNameId: shopName?.user_additional_information_id || null, // ID for shopName
            officeEmailInfoId:
              officeEmailInfo?.user_additional_information_id || null, // ID for workEmailAddress
            gstCheckboxId:
              gstButtonOptions?.user_additional_information_id || null, // ID for gstCheckbox
            turnOverId:
              businessTurnOver?.user_additional_information_id || null, // ID for turnOver
            gstNumberId: gstNumberInfo?.user_additional_information_id || null, // ID for gstNumber
            companyDocumentNumberId:
              companyDocumentNumberInfo?.user_additional_information_id || null, // ID for companyDocumentNumber
            companyPanNumberId:
              companyPanNumberInfo?.user_additional_information_id || null, // ID for companyPanNumber
            retailerOrWholesalerId:
              userRoleInfo?.user_additional_information_id || null, // ID for retailerOrWholesaler
            panCardDocumentId:
              panCardUploadInfo?.user_additional_information_id || null, // ID for panCard
            gstDocumentId:
              gstInUploadInfo?.user_additional_information_id || null, // ID for gstDocument
            companyOfficialDocumentId:
              companyOfficialDocumentUploadInfo?.user_additional_information_id ||
              null, // ID for companyOfficialDocument
            visitingCardId:
              vistingCardUploadInfo?.user_additional_information_id || null, // ID for visitingCard
            tdsDeclarationId:
              tdsDeclarationUploadInfo?.user_additional_information_id || null, // ID for tdsDeclaration
          }));

          setUserAdditionalQuestions((prevState) => ({
            ...prevState, // Retain existing state
            firstName: firstName?.user_additional_information_question, // Update firstName
            lastName: lastName?.user_additional_information_question, // Update lastName
            whatAppNumber: whatsAppNumber?.user_additional_information_question, // Update whatAppNumber
            userEmail: userEmail?.user_additional_information_question, // Update userEmail
            address: address?.user_additional_information_question, // Update address
            pinCode: pinCode?.user_additional_information_question, // Update pinCode
            city: city?.user_additional_information_question, // Update city
            district: district?.user_additional_information_question, // Update district
            state: state?.user_additional_information_question, // Update state
            referralCode: referralCode?.user_additional_information_question, // Update referralCode
            shopName: shopName?.user_additional_information_question, // Update shopName
            officeEmailInfo:
              officeEmailInfo?.user_additional_information_question, // Update workEmailAddress
            gstCheckbox: gstButtonOptions?.user_additional_information_question, // Update gstCheckbox
            turnOver: businessTurnOver?.user_additional_information_question, // Update turnOver
            gstNumber: gstNumberInfo?.user_additional_information_question, // Update gstNumber
            companyDocumentNumber:
              companyDocumentNumberInfo?.user_additional_information_question, // Update companyDocumentNumber
            companyPanNumber:
              companyPanNumberInfo?.user_additional_information_question, // Update companyPanNumber
            retailerOrWholesaler:
              userRoleInfo?.user_additional_information_question, // Update retailerOrWholesaler
            panCardDocument:
              panCardUploadInfo?.user_additional_information_question, // Update panCard
            gstDocument: gstInUploadInfo?.user_additional_information_question, // Update gstDocument
            companyOfficialDocument:
              companyOfficialDocumentUploadInfo?.user_additional_information_question, // Update companyOfficialDocument
            visitingCard:
              vistingCardUploadInfo?.user_additional_information_question, // Update visitingCard
            tdsDeclaration:
              tdsDeclarationUploadInfo?.user_additional_information_question, // Update tdsDeclaration
          }));

          setQueSeqNum((prevState) => ({
            ...prevState,
            firstName: firstName?.user_additional_information_seq_num,
            lastName: lastName?.user_additional_information_seq_num, // Update lastName
            whatAppNumber: whatsAppNumber?.user_additional_information_seq_num, // Update whatAppNumber
            userEmail: userEmail?.user_additional_information_seq_num, // Update userEmail
            address: address?.user_additional_information_seq_num, // Update address
            pinCode: pinCode?.user_additional_information_seq_num, // Update pinCode
            city: city?.user_additional_information_seq_num, // Update city
            district: district?.user_additional_information_seq_num, // Update district
            state: state?.user_additional_information_seq_num, // Update state
            referralCode: referralCode?.user_additional_information_seq_num, // Update referralCode
            shopName: shopName?.user_additional_information_seq_num, // Update shopName
            officeEmailInfo:
              officeEmailInfo?.user_additional_information_seq_num, // Update workEmailAddress
            gstCheckbox: gstButtonOptions?.user_additional_information_seq_num, // Update gstCheckbox
            turnOver: businessTurnOver?.user_additional_information_seq_num, // Update turnOver
            gstNumber: gstNumberInfo?.user_additional_information_seq_num, // Update gstNumber
            companyDocumentNumber:
              companyDocumentNumberInfo?.user_additional_information_seq_num, // Update companyDocumentNumber
            companyPanNumber:
              companyPanNumberInfo?.user_additional_information_seq_num, // Update companyPanNumber
            retailerOrWholesaler:
              userRoleInfo?.user_additional_information_seq_num, // Update retailerOrWholesaler
            panCardDocument:
              panCardUploadInfo?.user_additional_information_seq_num, // Update panCard
            gstDocument: gstInUploadInfo?.user_additional_information_seq_num, // Update gstDocument
            companyOfficialDocument:
              companyOfficialDocumentUploadInfo?.user_additional_information_seq_num, // Update companyOfficialDocument
            visitingCard:
              vistingCardUploadInfo?.user_additional_information_seq_num, // Update visitingCard
            tdsDeclaration:
              tdsDeclarationUploadInfo?.user_additional_information_seq_num, // Update tdsDeclaration
          }));

          setIsrequireFields((prevState) => ({
            ...prevState,
            firstName: firstName?.is_required,
            lastName: lastName?.is_required,
            whatAppNumber: whatsAppNumber?.is_required,
            userEmail: userEmail?.is_required,
            address: address?.is_required,
            pinCode: pinCode?.is_required,
            city: city?.is_required,
            district: district?.is_required,
            state: state?.is_required,
            referralCode: referralCode?.is_required,
            shopName: shopName?.is_required,
            officeEmailInfo: officeEmailInfo?.is_required,
            gstCheckbox: gstButtonOptions?.is_required,
            turnOver: businessTurnOver?.is_required,
            gstNumber: gstNumberInfo?.is_required,
            companyDocumentNumber: companyDocumentNumberInfo?.is_required,
            companyPanNumber: companyPanNumberInfo?.is_required,
            retailerOrWholesaler: userRoleInfo?.is_required,
            panCardDocument: panCardUploadInfo?.is_required,
            gstDocument: gstInUploadInfo?.is_required,
            companyOfficialDocument:
              companyOfficialDocumentUploadInfo?.is_required,
            visitingCard: vistingCardUploadInfo?.is_required,
            tdsDeclaration: tdsDeclarationUploadInfo?.is_required,
          }));
        }
      }),
    );
  }, [dispatch]);

  //user additional info answers API
  const handleUserAdditionalInfoAnswers = () => {
    let user_additional_information_data = [];
    if (formData.firstName) {
      user_additional_information_data.push({
        user_additional_information_id: userAdditionalQuestionsId.firstNameId,
        user_additional_information_data_value: formData.firstName,
      });
    }
    if (formData.lastName) {
      user_additional_information_data.push({
        user_additional_information_id: userAdditionalQuestionsId.lastNameId,
        user_additional_information_data_value: formData.lastName,
      });
    }
    if (formData.whatsAppNumber) {
      user_additional_information_data.push({
        user_additional_information_id:
          userAdditionalQuestionsId.whatsAppNumberId,
        user_additional_information_data_value: formData.whatsAppNumber,
      });
    }
    if (formData.userEmail) {
      user_additional_information_data.push({
        user_additional_information_id: userAdditionalQuestionsId.userEmailId,
        user_additional_information_data_value: formData.userEmail,
      });
    }
    if (formData.address) {
      user_additional_information_data.push({
        user_additional_information_id: userAdditionalQuestionsId.addressId,
        user_additional_information_data_value: formData.address,
      });
    }
    if (formData.pinCode) {
      user_additional_information_data.push({
        user_additional_information_id: userAdditionalQuestionsId.pinCodeId,
        user_additional_information_data_value: formData.pinCode,
      });
    }
    if (formData.city) {
      user_additional_information_data.push({
        user_additional_information_id: userAdditionalQuestionsId.cityId,
        user_additional_information_data_value: formData.city,
      });
    }
    if (formData.district) {
      user_additional_information_data.push({
        user_additional_information_id: userAdditionalQuestionsId.districtId,
        user_additional_information_data_value: formData.district,
      });
    }
    if (formData.state) {
      user_additional_information_data.push({
        user_additional_information_id: userAdditionalQuestionsId.stateId,
        user_additional_information_data_value: formData.state,
      });
    }
    if (formData.referralCode) {
      user_additional_information_data.push({
        user_additional_information_id:
          userAdditionalQuestionsId.referralCodeId,
        user_additional_information_data_value: formData.referralCode,
      });
    }
    if (formData.shopName) {
      user_additional_information_data.push({
        user_additional_information_id: userAdditionalQuestionsId.shopNameId,
        user_additional_information_data_value: formData.shopName,
      });
    }
    if (formData.workEmailAddress) {
      user_additional_information_data.push({
        user_additional_information_id:
          userAdditionalQuestionsId.officeEmailInfoId,
        user_additional_information_data_value: formData.workEmailAddress,
      });
    }
    if (formData.gstCheckbox) {
      user_additional_information_data.push({
        user_additional_information_id: userAdditionalQuestionsId.gstCheckboxId,
        user_additional_information_data_value: formData.gstCheckbox,
      });
    }
    if (formData.turnOver) {
      user_additional_information_data.push({
        user_additional_information_id: userAdditionalQuestionsId.turnOverId,
        user_additional_information_data_value: formData.turnOver,
      });
    }
    if (formData.gstNumber) {
      user_additional_information_data.push({
        user_additional_information_id: userAdditionalQuestionsId.gstNumberId,
        user_additional_information_data_value: formData.gstNumber,
      });
    }
    if (formData.companyDocumentNumber) {
      user_additional_information_data.push({
        user_additional_information_id:
          userAdditionalQuestionsId.companyDocumentNumberId,
        user_additional_information_data_value: formData.companyDocumentNumber,
      });
    }
    if (formData.companyPanNumber) {
      user_additional_information_data.push({
        user_additional_information_id:
          userAdditionalQuestionsId.companyPanNumberId,
        user_additional_information_data_value: formData.companyPanNumber,
      });
    }
    if (formData.retailerOrWholesaler) {
      user_additional_information_data.push({
        user_additional_information_id:
          userAdditionalQuestionsId.retailerOrWholesalerId,
        user_additional_information_data_value: formData.retailerOrWholesaler,
      });
    }
    if (formData.panCardFile) {
      user_additional_information_data.push({
        user_additional_information_id:
          userAdditionalQuestionsId.panCardDocumentId,
        user_additional_information_data_value: formData.panCardFile,
      });
    }
    if (formData.visitingCardFile) {
      user_additional_information_data.push({
        user_additional_information_id:
          userAdditionalQuestionsId.visitingCardId,
        user_additional_information_data_value: formData.visitingCardFile,
      });
    }
    if (formData.GSTDocumentFile) {
      user_additional_information_data.push({
        user_additional_information_id: userAdditionalQuestionsId.gstDocumentId,
        user_additional_information_data_value: formData.GSTDocumentFile,
      });
    }
    if (formData.companyDocumentFile) {
      user_additional_information_data.push({
        user_additional_information_id:
          userAdditionalQuestionsId.companyOfficialDocumentId,
        user_additional_information_data_value: formData.companyDocumentFile,
      });
    }
    if (formData.tdsDeclarationFile) {
      user_additional_information_data.push({
        user_additional_information_id:
          userAdditionalQuestionsId.tdsDeclarationId,
        user_additional_information_data_value: formData.tdsDeclarationFile,
      });
    }

    setUserAdditionalInfo(user_additional_information_data);
    const requestData = {
      user_additional_information_data: user_additional_information_data,
    };

    setTotalQueLen(requestData.user_additional_information_data.length);
    dispatch(
      addUserAddidtionalQuestionsAPI(requestData, (result) => {
        if (!result?.data?.status) {
          if (result?.data?.error?.code == 9109) {
            setErrors((prev) => ({
              ...prev,
              referralCode: result?.data?.error?.message,
            }));
          }
        }
      }),
    );
  };

  const totalSteps = 3; // Total number of steps

  useEffect(() => {
    let totalQueLength;
    if (formData?.turnOver) {
      totalQueLength = 21;
    } else {
      totalQueLength = 20;
    }

    if (totalQueLen >= 20 || 21) {
      setSubmitDisabled(false);
    } else {
    }
  }, []);

  const handleSubmit = async () => {
    if (!validateCurrentStep()) {
      return;
    }

    const requestData = {
      user_additional_information_data: userAdditionalInfo, // Assuming this is created elsewhere
      flagOnboarded: true, // Append the flag here
    };
    // return
    try {
      // Dispatch the action with updated requestData
      dispatch(
        addUserAddidtionalQuestionsAPI(requestData, (result) => {
          if (result?.data?.status) {
            dispatch(setOnboardingFlag(true));
            localStorage.setItem("flagOnboarded", true); //will remove this line not used at anywhere
            localStorage.setItem(
              "isRefillingOnboardingFormIsNowInReviewed",
              "true",
            );
            localStorage.removeItem("isRefillingOnboardingForm");
            navigate(
              "/profile-under-review",
              { state: { fromOnboardingSubmitButton: true } },
              { replace: true },
            ); // Redirect user back to this page
            sessionStorage.removeItem("onboardingMobileNumber"); // ✅ clean up after done
            // Push a new history entry to disable the back button functionality
            window.history.pushState(null, "", window.location.href);

            // Prevent going back to the previous page
            window.onpopstate = () => {
              window.history.go(1);
            };

            // Set the onboarding flag in Redux
            dispatch(setOnboardingCompleted());
          }
        }),
      );
    } catch (error) {
      console.log("Error during submission:", error);
    }
  };

  // Validate the current steps
  const validateCurrentStep = () => {
    let isValid = true;
    const newErrors = {};

    if (currentStep === 0) {
      const requiredFields = [
        // // "firstName",
        // isRequireFields?.firstName == true ? "firstName" : "",
        // // "lastName",
        // isRequireFields?.lastName == true ? "lastName" : "",
        // // "whatsAppNumber",
        // isRequireFields?.whatAppNumber == true ? "whatsAppNumber" : "",
        // // "userEmail",
        // // "address",
        // isRequireFields?.address == true ? "address" : "",
        // // "pinCode",
        // isRequireFields?.pinCode == true ? "pinCode" : "",
        // // "city",
        // isRequireFields?.city == true ? "city" : "",
        // // "district",
        // isRequireFields?.district == true ? "district" : "",
        // // "state",
        // isRequireFields?.state == true ? "state" : "",
        // isRequireFields?.referralCode == true ? "referralCode" : "",

        isRequireFields?.firstName ? "firstName" : null,
        isRequireFields?.lastName ? "lastName" : null,
        isRequireFields?.whatAppNumber ? "whatsAppNumber" : null,
        isRequireFields?.userEmail ? "userEmail" : null,
        isRequireFields?.address ? "address" : null,
        isRequireFields?.pinCode ? "pinCode" : null,
        isRequireFields?.city ? "city" : null,
        isRequireFields?.district ? "district" : null,
        isRequireFields?.state ? "state" : null,
        isRequireFields?.referralCode ? "referralCode" : null,
      ].filter(Boolean); // Removes null/empty values

      // Check for missing required fields
      requiredFields.forEach((field) => {
        const value =
          formData[field] || userOnboardingDetails[field]?.toString().trim(); // Ensures values like 0 are valid, trims extra spaces

        if (!value) {
          newErrors[field] = `${field
            .replace(/([A-Z])/g, " $1")
            .toLowerCase()} is required`; // Makes 'firstName' to 'First Name' for readability
          isValid = false;
        }
      });

      // Additional validation for email and pinCode and whatsapp number
      if (
        formData.userEmail &&
        !/^\S+@\S+\.\S+$/.test(formData.userEmail.trim())
      ) {
        newErrors.userEmail = "Invalid email format";
        isValid = false;
      }

      if (
        formData.pinCode &&
        !/^\d{6}$/.test(formData.pinCode.toString().trim())
      ) {
        newErrors.pinCode = "Invalid pin code";
        isValid = false;
      }
      if (
        formData.whatsAppNumber &&
        !/^[6-9]\d{9}$/.test(formData.whatsAppNumber.trim())
      ) {
        newErrors.whatsAppNumber = "Invalid WhatsApp number";
        isValid = false;
      }
    }

    if (currentStep === 1) {
      // let requiredFields = [
      //   // "shopName",
      //   isRequireFields?.shopName ? "shopName" : "",
      //   // "workEmailAddress",
      //   isRequireFields?.officeEmailInfo ? "workEmailAddress" : "",
      //   // "gstCheckbox",
      //   isRequireFields?.gstCheckbox ? "gstCheckbox" : "",
      //   // "turnOver",
      //   isRequireFields?.turnOver ? "turnOver" : "",
      //   // "gstNumber",
      //   // "companyDocumentNumber",
      //   // "companyPanNumber",
      //   isRequireFields?.companyPanNumber ? "companyPanNumber" : "",
      //   // "retailerOrWholesaler",
      //   isRequireFields?.retailerOrWholesaler ? "retailerOrWholesaler" : "",
      // ];
      let requiredFields = [
        isRequireFields?.shopName ? "shopName" : null,
        isRequireFields?.officeEmailInfo ? "workEmailAddress" : null,
        isRequireFields?.gstCheckbox ? "gstCheckbox" : null,
        isRequireFields?.turnOver ? "turnOver" : null,
        // ✅ only validate PAN if GST is not Yes (field is hidden when Yes)
        isRequireFields?.companyPanNumber && formData.gstCheckbox !== "Yes"
          ? "companyPanNumber"
          : null,
        isRequireFields?.retailerOrWholesaler ? "retailerOrWholesaler" : null,
      ].filter(Boolean);
      requiredFields.forEach((field) => {
        const value = formData[field]?.toString().trim();
        if (!value) {
          newErrors[field] = `${field
            .replace(/([A-Z])/g, " $1")
            .toLowerCase()} is required`;
          isValid = false;
        }
      });

      // GST and PAN validation
      const gstRegex =
        /^[0-3][0-9][A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
      const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
      const emailRegex = /^\S+@\S+\.\S+$/;

      if (
        formData.workEmailAddress &&
        !emailRegex.test(formData.workEmailAddress.trim())
      ) {
        newErrors.workEmailAddress = "Invalid email format";
        isValid = false;
      }

      // GSTIN or Company Document validation based on gstCheckbox
      if (formData.gstCheckbox === "Yes") {
        if (!formData.gstNumber) {
          newErrors.gstNumber = "GSTIN is required";
          isValid = false;
        } else if (!gstRegex.test(formData.gstNumber.trim())) {
          newErrors.gstNumber = "Invalid GSTIN format";
          isValid = false;
        }
      } else if (formData.gstCheckbox === "No") {
        newErrors.gstNumber = "";
        // if (!formData.companyDocumentNumber) {
        //   newErrors.companyDocumentNumber =
        //     "Company Document Number is required";
        //   isValid = false;
        // }
      }

      // if (!formData.gstNumber && !formData.companyDocumentNumber) {
      //   if (formData.gstCheckbox === "Yes") {
      //     newErrors.gstNumber = "GSTIN is required";
      //   } else {
      //     newErrors.companyDocumentNumber = "Company Document Number is required";
      //   }
      //   isValid = false;
      // }

      // if (formData.gstCheckbox === "Yes") {
      //   if (formData.gstNumber && !gstRegex.test(formData.gstNumber.trim())) {
      //     newErrors.gstNumber = "Invalid GST Number";
      //     isValid = false;
      //   }
      // } else {
      //   newErrors.gstNumber = "";
      // }

      if (
        formData.companyPanNumber &&
        !panRegex.test(formData.companyPanNumber.trim())
      ) {
        newErrors.companyPanNumber = "Invalid PAN Number";
        isValid = false;
      }
    }

    if (currentStep === 2) {
      // const requiredFiles = {
      //   panCardFile: isRequireFields?.panCardDocument
      //     ? "PAN card file is required"
      //     : "",
      //   visitingCardFile: isRequireFields?.visitingCard
      //     ? "Visiting card file is required"
      //     : "",
      //   GSTDocumentFile:
      //     isRequireFields?.gstDocument && formData.gstCheckbox === "Yes"
      //       ? "GST document file is required"
      //       : "",
      //   companyDocumentFile:
      //     isRequireFields?.companyOfficialDocument &&
      //     formData.gstCheckbox === "No"
      //       ? "Company document file is required"
      //       : "",
      //   tdsDeclarationFile:
      //     isRequireFields?.tdsDeclaration && formData.turnOver === "Yes"
      //       ? "TDS declaration file is required"
      //       : "",
      // };
      const requiredFiles = {
        // ✅ PAN only when GST = No
        panCardFile:
          isRequireFields?.panCardDocument && formData.gstCheckbox === "No"
            ? "PAN card file is required"
            : "",
        // ✅ visiting card only when GST = No
        visitingCardFile:
          isRequireFields?.visitingCard && formData.gstCheckbox === "No"
            ? "Visiting card file is required"
            : "",
        // ✅ GST doc only when GST = Yes
        GSTDocumentFile:
          isRequireFields?.gstDocument && formData.gstCheckbox === "Yes"
            ? "GST document file is required"
            : "",
        // ✅ company doc only when GST = No
        // companyDocumentFile:
        //   isRequireFields?.companyOfficialDocument &&
        //   formData.gstCheckbox === "No"
        //     ? "Company document file is required"
        //     : "",
        tdsDeclarationFile:
          isRequireFields?.tdsDeclaration && formData.turnOver === "Yes"
            ? "TDS declaration file is required"
            : "",
      };

      Object.keys(requiredFiles).forEach((key) => {
        if (!formData[key] && requiredFiles[key]) {
          newErrors[key] = requiredFiles[key];
          isValid = false;
        }
      });
    }

    setErrors(newErrors);
    return isValid;
  };

  const stepText = [
    "Tell Us More About You",
    "Tell Us More About Your Business",
    "Upload Documents",
  ];

  return (
    <>
      <div className="mainDiv">
        <OnboardingHeader />
        {/* <div style={{ position: "sticky", top: 0 }}>
          <div className="section-1-div">
            <HeaderBlack noLoginBtn={true} />
          </div>
        </div> */}
        {currentStep === 0 && (
          <PersonalInfo
            text={stepText[0]}
            formData={formData}
            setFormData={setFormData}
            errors={errors}
            setErrors={setErrors} // Pass setErrors here
            handleMouseOutForPinCode={handleMouseOutForPinCode}
            handleFormFieldChange={handleUserAdditionalInfoAnswers}
            userOnboardingDetails={userOnboardingDetails}
            userOnboardingQuestions={userAdditionalQuestions}
            questionSequenceNumber={queSeqNum}
            isRequireFields={isRequireFields}
          />
        )}
        {currentStep === 1 && (
          <BusinessInfo
            text={stepText[1]}
            formData={formData}
            setFormData={setFormData}
            errors={errors}
            setErrors={setErrors} // Pass setErrors here
            handleFormFieldChange={handleUserAdditionalInfoAnswers}
            userOnboardingDetails={userOnboardingDetails}
            userOnboardingQuestions={userAdditionalQuestions}
            questionSequenceNumber={queSeqNum}
            isRequireFields={isRequireFields}
          />
        )}
        {currentStep === 2 && (
          <UploadDocument
            text={stepText[2]}
            formData={formData}
            setFormData={setFormData}
            errors={errors}
            setErrors={setErrors} // Pass setErrors here
            handleFormFieldChange={handleUserAdditionalInfoAnswers}
            userOnboardingDetails={userOnboardingDetails}
            userOnboardingQuestions={userAdditionalQuestions}
            questionSequenceNumber={queSeqNum}
            isRequireFields={isRequireFields}
          />
        )}
        <OnboardingButtons
          currentStep={currentStep}
          onBackClick={handleBackClick}
          onNextClick={handleNextClick}
          onSubmit={handleSubmit}
          isSubmitDisabled={isSubmitDisabled}
        />
      </div>
    </>
  );
};

export default Onboarding;
